import { useMemo } from "react";
import { ArrowUpRight } from "lucide-react";
import { MLS_SEARCH_URL } from "@/lib/guides";
import { Container, PillButton, SectionHeading } from "@/components/common/ui";
import { ListingCard } from "@/components/listings/ListingCard";
import { useListings } from "@/hooks/useData";

export const FeaturedHomes = () => {
  const params = useMemo(() => ({ sort: "newest", limit: 3 }), []);
  const { data } = useListings(params);
  return (
    <section className="py-16 sm:py-20" data-testid="featured-homes">
      <Container>
        <SectionHeading
          title="Homes near the bases"
          subtitle={data?.sample ? "Sample listings shown while the REIN MLS feed is being connected. Every home shows its distance to the nearest installation." : "Fresh REIN listings, each with its distance to the nearest installation."}
        />
        <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {(data?.listings || []).map((l) => <ListingCard key={l.listing_key} listing={l} />)}
          <div className="flex min-h-[320px] flex-col justify-between rounded-md bg-ink p-7 text-white" data-testid="featured-pcs-panel">
            <div>
              <p className="eyebrow !text-brass">PCS concierge</p>
              <p className="mt-4 font-display text-3xl leading-tight">Shopping from out of town?</p>
              <p className="mt-3 text-[15px] text-white/75">
                We help military clients make the most out of their house hunting leave time ahead of their move.
              </p>
            </div>
            <PillButton to="/military#pcs-form" tone="light" className="mt-6 self-start" testId="featured-pcs-cta">Plan my move</PillButton>
          </div>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <PillButton to="/search" testId="featured-view-all">View all homes on the map</PillButton>
          <a href={MLS_SEARCH_URL} target="_blank" rel="noopener noreferrer" data-testid="featured-mls-search"
            className="inline-flex h-12 items-center gap-2 rounded-full border border-ink px-6 text-[15px] text-ink transition-colors hover:bg-ink hover:text-white">
            Search every MLS home <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </Container>
    </section>
  );
};
